var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueIndicatorShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "62px",
    viewBox: "0 0 32 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "value-indicator-shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit---Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Local/Icons/03-Value-indicator/Value-indicator",
    fill: "#7D1E4F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.85,0.01 32,7.16 32,16 C32,20.42 29.9823992,24.42 27.0923992,27.31 C26.2703479,28.1320513 25.125679,29.1038828 23.995947,30.1066885 L23.5136748,30.5380124 C21.6760151,32.1960346 20.0088205,33.8918479 20.0088205,35.0986622 C20.0169754,37.0082899 20.9861629,38.7067702 22.9163829,40.1941029 C25.9925078,42.36655 28,45.9488375 28,50 C28,56.627417 22.627417,62 16,62 C9.372583,62 4,56.627417 4,50 C4,46.0015756 5.95556527,42.459898 8.96243513,40.2792277 C8.96993397,40.2704425 8.98146011,40.2610007 8.99440157,40.2514718 C11.0329183,38.7504906 12.0521766,37.0328874 12.0521766,35.0986622 C12.0521766,33.0523249 6.97,29.6 4.68,27.31 C1.79,24.42 0,20.42 0,16 C0,7.16 7.15,0.01 16,0 Z",
    id: "value-indicator-shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueIndicatorShape);
export default __webpack_public_path__ + "static/media/value-indicator-shape.fe4a2d26822540d9359c8035dd8e7128.svg";
export { ForwardRef as ReactComponent };